module.exports = __webpack_public_path__ + "media/images/icons/filled/sketch-square-194e70df3c9e5744137077bb5e33fe5b.svg";